import { baseformulaeditor } from './baseformulaeditor.js';

window.formulatemplates_description_dialog = function () {

    var instance = {
        CloseDialog: function () {
            var dialogFormulaTemplate = document.querySelector("div[id='dict_formulatemplate_list_dialog']");
            if (dialogFormulaTemplate != null)
                dialogFormulaTemplate.remove();
        },
        setonclicksCloseDialog: function () {
            var _this = this;
            document.querySelectorAll("td[selectFTCell*='trID_']").forEach(function (cell) {
                cell.querySelectorAll("a").forEach(function (a) {
                    a.addEventListener("click", function () {
                        _this.CloseDialog();
                    });
                });
            });
            if (document.querySelector('form[id="dict_formulatemplate_list_form"]') != null) {
                var closeButton = document.querySelector('form[id="dict_formulatemplate_list_form"]').querySelector('button[type="button"],button[class="close"]');
                if (closeButton != null) {
                    closeButton.addEventListener("click", function () {
                        var formTitle = document.querySelector('div[id*="_right_tabsright_tformulaviewtexttab_"]').querySelector('a[data-info_formula_edit_title]').getAttribute('data-info_formula_edit_title');
                        if (formTitle != null) {
                            document.title = formTitle;
                        }
                    });
                }
            }
        },
    }
    return instance;

}();

class formulatemplates_description_edit extends baseformulaeditor {
	widgetDidMount() {
		var _this = this;

		_this.onChangeFormula();
		///TODO: переделать на ID
		var table = document.querySelector("table[data-tformuladesc]");
		if (table) {
			table.querySelectorAll("a[data-removerow]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.removerow();
				});
			});

			table.querySelectorAll("input[name='objectlabel']").forEach(function (a) {
				a.addEventListener("change", (event) => {
					_this.onChangeFormula();
				});
            });

            table.querySelectorAll("select[name='objectchannel']").forEach(function (a) {
                a.addEventListener("change", (event) => {
                    _this.onChangeFormula();
                });
            });

			table.querySelectorAll("a[data-moverowup]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.moverowup();
				});
			});

			table.querySelectorAll("a[data-moverowdown]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.moverowdown();
				});
			});

			table.querySelectorAll("a[data-addrowup]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.addrowup();
				});
			});

			table.querySelectorAll("a[data-addrowdown]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.addrowdown();
				});
			});

			table.querySelectorAll("a[data-editOperBefore]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.editOperand("Before");
				});
			});

			table.querySelectorAll("a[data-editOperAfter]").forEach(function (a) {
				a.addEventListener("click", function () {
					_this.editOperand("After");
				});
			});

			table.querySelectorAll("input[data-tbOperAfter='']").forEach(function (a) {
				a.addEventListener("focusout", function () {
					_this.onLostFocusTbEdit("After");
				});
				a.addEventListener("keypress", function (e) {
					if (e.keyCode == 13) {
						_this.onLostFocusTbEdit("After");
					}
				});
			});
			table.querySelectorAll("input[data-tbOperBefore='']").forEach(function (a) {
				a.addEventListener("focusout", function () {
					_this.onLostFocusTbEdit("Before");
				});
				a.addEventListener("keypress", function (e) {
					if (e.keyCode == 13) {
						_this.onLostFocusTbEdit("Before");
					}
				});
			});

			table.querySelectorAll("td[data-tdobjectcolumn]").forEach(function (td) {
				td.addEventListener("click", function () {
					_this.setSelectedRows(td);
				});
			});

			document.querySelectorAll("a[data-ot-ctr-setClick='false']").forEach(function (a) {
				var arg = a.getAttribute('data-addcontract');
				a.addEventListener("click", function () {
					_this.addcontract(arg = '' ? null : arg);
				});
			});

			document.querySelectorAll("a[data-ot-cl-setClick='false']").forEach(function (a) {
				var arg = a.getAttribute('data-addclausecontract');
				a.addEventListener("click", function () {
					_this.addclausecontract(arg = '' ? null : arg);
				});
			});

			_this.setVisibleUpDownButton();
        }		
	}

	setNewRowProps() {
		var _this = this;
		var row = document.querySelector("tr[data-newrow='true']");
		//row.querySelector("span[data-objectlabel]").innerHTML = "";

		row.querySelector("span[data-spanoperafter]").innerHTML = "";
		row.querySelector("span[data-spanoperbefore]").innerHTML = "";

        row.querySelector("input[name='tboperbefore']").innerHTML = "";
        row.querySelector("input[name='tboperafter']").innerHTML = "";
        row.querySelector("input[name='tboperbefore']").setAttribute("value", "");
        row.querySelector("input[name='tboperafter']").setAttribute("value", "");

		row.querySelector("input[name='objectlabel']").value = "";
		row.querySelector("input[name='objectlabel']").addEventListener("change", (event) => {
			this.onChangeFormula();
		});

		row.querySelector("input[name='tboperbefore']").innerHTML = "";
        row.querySelector("input[name='tboperafter']").innerHTML = "";

        //Clear select Channel
        row.querySelector("select[name='objectchannel']")[1].selected = false;
        row.querySelector("select[name='objectchannel']")[2].selected = false;
        row.querySelector("select[name='objectchannel']")[3].selected = false;
        row.querySelector("select[name='objectchannel']")[4].selected = false;
        row.querySelector("select[name='objectchannel']").addEventListener("change", (event) => {
            this.onChangeFormula();
        });

		var isSelected = row.getAttribute("selectinserted");
		if (isSelected != null && isSelected == "true") {
			row.style.backgroundColor = null;
		}

		row.removeAttribute('data-newrow');
		row.removeAttribute('data-description');
		var spanObject = row.querySelector("span[data-objectlabel]");
		if(spanObject != null){
		//	spanObject.removeAttribute('attrdescr-iscontract');
		//	spanObject.removeAttribute('attrdescr-iscontractclause');
		//	spanObject.removeAttribute('attrdescr-sectionid');
		//	spanObject.removeAttribute('attrdescr-sectiondataid');
            spanObject.removeAttribute('attrdescr-channel');
		}

		row.querySelector("a[data-addrowdown]").addEventListener("click", function () {
			_this.addrowdown();
		});

		row.querySelector("input[data-tbOperBefore='']").addEventListener("keypress", function (e) {
			if (e.keyCode == 13) _this.onLostFocusTbEdit("Before");
		});
		row.querySelector("input[data-tbOperAfter='']").addEventListener("keypress", function (e) {
			if (e.keyCode == 13) _this.onLostFocusTbEdit("After");
		});

		row.querySelector("input[data-tbOperAfter='']").addEventListener("focusout", function () {
			_this.onLostFocusTbEdit("After");
		});
		row.querySelector("input[data-tbOperBefore='']").addEventListener("focusout", function () {
			_this.onLostFocusTbEdit("Before");
		});

		row.querySelector("a[data-editOperBefore]").addEventListener("click", function () {
			_this.editOperand("Before");
		});
		row.querySelector("a[data-editOperAfter]").addEventListener("click", function () {
			_this.editOperand("After");
		});

		row.querySelector("a[data-removerow]").addEventListener("click", function () {
			_this.removerow();
		});

		var td = row.querySelector("td[data-tdobjectcolumn]");
		row.querySelector("td[data-tdobjectcolumn]").addEventListener("click", function () {
			_this.setSelectedRows(td);
		});

		row.querySelector("a[data-moverowup]").addEventListener("click", function () {
			_this.moverowup();
		});
		row.querySelector("a[data-moverowdown]").addEventListener("click", function () {
			_this.moverowdown();
		});

	}
	
    onChangeFormula() {
        try {
            var table = document.querySelector("table[data-tformuladesc='tformuladesc']");
            var dictDescNew = new Object();
            var rows = table.querySelectorAll("tr[data-rid]");
            rows.forEach(function (tr) {
                var number = tr.getAttribute("data-rid");
                if (!dictDescNew[number])
                    dictDescNew[number] = {};
                //dictDescNew[number].stringnumber = document.querySelector("input[name='formula_un']").value;
                dictDescNew[number].stringnumber = number;
                dictDescNew[number].operBefore = tr.querySelector("span[data-spanoperbefore]").innerHTML;
                dictDescNew[number].operAfter = tr.querySelector("span[data-spanoperafter]").innerHTML;
                if (tr.querySelector("input[name='objectlabel']").value != null)
                    dictDescNew[number].Variable = tr.querySelector("input[name='objectlabel']").value;//.replace('+', 'plus').replace('*', 'multiply')/*.repalce('(','')*/;
                //if (tr.querySelector("span[attrdescr-iscontract]") != null)
                //	dictDescNew[number].contract_ID = tr.querySelector("span[attrdescr-iscontract]").getAttribute("attrdescr-iscontract");
                //if (tr.querySelector("span[attrdescr-iscontractclause]") != null)
                //	dictDescNew[number].contract_ID = tr.querySelector("span[attrdescr-iscontractclause]").getAttribute("attrdescr-iscontractclause");
                //if (tr.querySelector("span[attrdescr-sectionid]") != null)
                //	dictDescNew[number].ei_Section_ID = tr.querySelector("span[attrdescr-sectionid]").getAttribute("attrdescr-sectionid");
                //if (tr.querySelector("span[attrdescr-sectiondataid]") != null)
                //	dictDescNew[number].ei_Section_Data_ID = tr.querySelector("span[attrdescr-sectiondataid]").getAttribute("attrdescr-sectiondataid");;
                if (tr.querySelector("select[name='objectchannel']") != null) {
                    var channel = tr.querySelector("select[name='objectchannel']");
                    var channelValue = channel.value;
                    dictDescNew[number].ChannelType = channelValue;
                }
            });
        }
        catch (exc) {
            console.log(exc);
        };

        try {
            document.querySelector("input[name='formulajson']").value = JSON.stringify(dictDescNew);
        }
        catch (exc) {
            console.log(exc);
        };
	}
};

Tango.registerComponent(formulatemplates_description_edit, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));
